import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { MyorderModel, MyorderDetailModel } from '../model/MyorderModel.js';

/**
 * @method apiGetOrderHistory
 */
export default {
    apiGetOrderHistory: function (params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/order';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            var arrMyorder = [];
            for (var i of res.data) {
                var objMyorder = new MyorderModel(i);
                arrMyorder.push(objMyorder);
            }

            return arrMyorder;
        }));
    },
    apiGetOrderTracking: function () {
        let token = Account.getToken();
        let userId = Account.getCacheUser().userId;
        let url = ConfigManager.getApiModuleUrl() + '/order/' + userId + '/tracking';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            var arrMyorder = [];
            for (var i of res.data) {
                var objMyorder = new MyorderModel(i);
                arrMyorder.push(objMyorder);
            }

            return arrMyorder;
        }));
    },
    apiGetOrderHistoryDetail: function (tranId) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/order/' + tranId;
        return BzbsApi.connectBzbsGet(url, token).pipe(map((res) => {
            var arrMyorder = [];
            for (var i of res.data) {
                var objMyorder = new MyorderDetailModel(i);
                arrMyorder.push(objMyorder);
            }

            return arrMyorder;
        }));
    },

    apiPostReOrder: function (tranId) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/order/' + tranId + '/reorder';
        return BzbsApi.connectBzbsPost(url, token).pipe(map((res) => {
            return res.data;
        }));
    },
    apiPostFavourite: function (tranId) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/order/' + tranId + '/favourite';
        return BzbsApi.connectBzbsPost(url, token).pipe(map((res) => {
            return res.data;
        }));
    },
    apiTrackingGuestOrder: function (searchTerm) {
        let token = Account.getToken()
        let url = ConfigManager.getApiModuleUrl() + "/order/" + searchTerm + "/guest_tracking"
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

    apiGetFree: function (tranId){
        let token = Account.getToken()
        let url = ConfigManager.getApiModuleUrl() + "/order/" + tranId + "/free_reward"
        return BzbsApi.connectBzbsGet(url, token).pipe(map((res) => {
            return res.data;
        }));
    },
}
